module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/H7EAQL/tc-custom/9781488068638.jpg?1708084683127",
      "alt": "This image is the cover for the book Forbidden Cabrera Brother"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Forbidden Cabrera Brother\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An irresistible billionaire bachelor stirs up drama with his brother’s fiancée in this romantic tale of desire by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _c('i', [_vm._v("They’re supposed to resist each other . . . But can they?")]), _c('br'), _c('br'), _vm._v("A fake engagement to her best friend was meant to save Caitlin’s family from crippling debt. Not lead to a totally off-limits entanglement with Dante Cabrera, Spain’s most eligible bachelor and her future brother-in-law!"), _c('br'), _c('br'), _vm._v("Dante doesn’t trust easily. Not after a disastrous relationship left its mark on him. His plan is to not let Caitlin out of his sight until he uncovers her motives. But fighting their intense connection threatens to undo even this notorious playboy’s control . . .\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cathy Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Cathy Williams is a great believer in the power of perseverance as she had never written anything before her writing career, and from the starting point of zero has now fulfilled her ambition to pursue this most enjoyable of careers. She would encourage any would-be writer to have faith and go for it! She derives inspiration from the tropical island of Trinidad and from the peaceful countryside of middle England. Cathy lives in Warwickshire her family.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0